import { useMutation } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { cnmcQueryKeys } from './query-keys';

export type TProcessCNMCParams = {
  cnmcId: string;
};

export async function processCNMC({ cnmcId }: TProcessCNMCParams): Promise<undefined> {
  return mediaManagerClient.post(`/api/v1/cnmcs/${cnmcId}/process`);
}

type MutationFn = typeof processCNMC;

type TUseProcessCNMCParams = {
  config?: MutationConfig<MutationFn>;
};

export function useProcessCNMC({ config = {} }: TUseProcessCNMCParams = {}) {
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: processCNMC,
    onError: error => {
      const { status } = parseError(error);
      if (status === 404) {
        addErrorNotification('El proceso no existe');
      } else {
        addErrorNotification('Error al iniciar el proceso de IA');
      }
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: cnmcQueryKeys.all });
      addSuccessNotification('Proceso de IA iniciado con éxito');
    },
  });
}
